<h2 mat-dialog-title>Configure Export</h2>
<mat-dialog-content class="dialog-content">
  <!-- Export layout -->
  <section class="config-section">
    <h3 id="export-layout-label" class="config-section-title">Layout</h3>
    <mat-radio-group
      class="layout-group"
      aria-labelledby="export-layout-label"
      [(ngModel)]="layout"
      [disabled]="isExporting"
    >
      <mat-radio-button value="grouped">
        <span class="option-title">Grouped data</span>
        <span class="option-sub">{{ layoutDescriptions.grouped }}</span>
      </mat-radio-button>
      <mat-radio-button value="flattened">
        <span class="option-title">Flattened data</span>
        <span class="option-sub">{{ layoutDescriptions.flattened }}</span>
      </mat-radio-button>
    </mat-radio-group>
  </section>

  <!-- Billing time period (hidden for exports without billing-hours columns) -->
  @if (showBillingPeriod) {
    <section class="config-section">
      <h3 class="config-section-title">Billing time period</h3>
      <p class="config-section-hint">
        Sets the window covered by the billing-hours columns.
      </p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Time period</mat-label>
        <mat-select [(value)]="dateRangeKey" [disabled]="isExporting">
          @for (option of dateRangeOptions; track option.key) {
            <mat-option [value]="option.key">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (isCustomRange) {
        <div class="custom-range" @expandCollapse>
          <mat-form-field appearance="outline" class="custom-date-field">
            <mat-label>Start date</mat-label>
            <input
              matInput
              [matDatepicker]="startPicker"
              [(ngModel)]="customStartDate"
              [disabled]="isExporting"
              placeholder="mm/dd/yyyy"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startPicker"
              [disabled]="isExporting"
            ></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" class="custom-date-field">
            <mat-label>End date</mat-label>
            <input
              matInput
              [matDatepicker]="endPicker"
              [(ngModel)]="customEndDate"
              [min]="customStartDate"
              [disabled]="isExporting"
              placeholder="mm/dd/yyyy"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endPicker"
              [disabled]="isExporting"
            ></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
      }
    </section>
  }

  <!-- Time off entries (hidden for exports that don't carry them) -->
  @if (showTimeOffEntries) {
    <section class="config-section">
      <h3 class="config-section-title">Time off entries</h3>
      <p class="config-section-hint">
        Choose which entries appear in the export. Add <strong>Past</strong> to
        include past time off requests.
      </p>
      <div class="time-off-filters">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Status</mat-label>
          <mat-select [(value)]="statusCodes" multiple [disabled]="isExporting">
            @for (option of statusOptions; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Time frame</mat-label>
          <mat-select [(value)]="timeFrames" multiple [disabled]="isExporting">
            @for (option of timeFrameOptions; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </section>
  }

  <!-- Inherited list filters (read-only) -->
  <p class="inherited-filters">
    <mat-icon class="inherited-filters-icon">filter_alt</mat-icon>
    <span>
      Exporting {{ subjectLabel }} matching your current
      {{ data.viewLabel }} filters
      @if (data.activeFilterCount > 0) {
        ({{ data.activeFilterCount }}
        {{ data.activeFilterCount === 1 ? "filter" : "filters" }} active)
      } @else {
        (no filters active)
      }
    </span>
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-stroked-button
    class="cancel-button"
    (click)="onCancel()"
  >
    Cancel
  </button>
  <button
    mat-flat-button
    class="export-button"
    [class.is-exporting]="isExporting"
    [disabled]="!isValid || isExporting"
    (click)="onExport()"
  >
    @if (isExporting) {
      <span class="export-button-content">
        <mat-spinner diameter="18"></mat-spinner>
        <span>Exporting…</span>
      </span>
    } @else {
      Export
    }
  </button>
</mat-dialog-actions>
